import { useState } from 'react';
import styled from 'styled-components';
import Select from 'react-select';

interface IProps {
  titleList: CardGraph[];
  status?: 'ALL' | 'SAVED' | 'CANCELED';
  setStatus?: (status: 'ALL' | 'SAVED' | 'CANCELED') => void;
  setPageNumber?: (page: number) => void;
}

interface CardGraph {
  id: number;
  title: string;
  flex: number;
}

function FXTableHeader({
  titleList,
  status = 'ALL',
  setStatus,
  setPageNumber,
}: IProps) {
  const statusOptions = [
    { label: '발행 상태', value: 'ALL' },
    { label: '발행 완료', value: 'SAVED' },
    { label: '발행 취소', value: 'CANCELED' },
  ];

  const [selectedStatus, setSelectedStatus] = useState<{
    label: string;
    value: string;
  }>(
    statusOptions.find((option) => option.value === status) || statusOptions[0],
  );

  const onChangeStatus = (e: any) => {
    setSelectedStatus(e);
    if (setStatus) {
      setStatus(e.value);
    }
    if (setPageNumber) {
      setPageNumber(0);
    }
  };

  const renderHeaderContent = (title: string) => {
    if (title === '발행 상태') {
      return (
        <SelectWrapper>
          <Select
            isSearchable={false}
            value={selectedStatus}
            onChange={onChangeStatus}
            options={statusOptions}
            styles={{
              container: (baseStyles: any) => ({
                ...baseStyles,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'transparent',
                textAlign: 'center',
              }),
              control: () => ({
                display: 'flex',
                alignItems: 'center',
                minWidth: 100,
                height: 21,
                border: 'none',
                backgroundColor: 'transparent',
              }),
              indicatorSeparator: () => ({
                width: 0,
              }),
              singleValue: (baseStyles: any) => ({
                ...baseStyles,
                color: '#5F6165',
                textOverflow: 'none',
              }),
              dropdownIndicator: (baseStyles: any) => ({
                ...baseStyles,
                color: '#5F6165',
                paddingLeft: 0,
              }),
            }}
          />
        </SelectWrapper>
      );
    }

    return title;
  };

  return (
    <thead>
      <HeaderRow>
        {titleList.map((card) => (
          <HeaderCell key={card.id} width={card.flex}>
            {renderHeaderContent(card.title)}
          </HeaderCell>
        ))}
      </HeaderRow>
    </thead>
  );
}

const HeaderRow = styled.tr`
  height: 48px;
  background-color: ${(props) => props.theme.mono[10]};
  border-bottom: 1px solid ${(props) => props.theme.mono[35]};
  text-align: center;
`;

const HeaderCell = styled.th<{ width: number }>`
  width: ${(props) => `${(props.width / 10.25) * 100}%`};
  padding: 8px 4px;
  font-size: ${(props) => props.theme.fontSize.xSmall};
  font-weight: ${(props) => props.theme.fontWeight.medium};
  line-height: ${(props) => props.theme.lineHeight.xSmall};
  white-space: pre;
  text-align: center;
  vertical-align: middle;
  color: ${(props) => props.theme.mono[65]};

  @media ${(props) => props.theme.mediumView} {
    padding: 8px 8px;
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default FXTableHeader;
